import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Targeting } from "@front/m19-api-client";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { CsvExportService, simpleField } from "@m19-board/services/csv-export.service";
import { KeywordListManagerComponent } from "@m19-board/shared/keyword-list-manager/keyword-list-manager.component";

export type UpdateOperations<T> = {
  toAdd: T[];
  toDelete: T[];
};

export type BlacklistModalData = {
  blacklist: Targeting[] | undefined;
  isReadOnly: boolean;
};

@Component({
  templateUrl: "./blacklist-modal.component.html",
  imports: [TranslocoDirective, FormsModule, IButtonDirective, KeywordListManagerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlacklistModalComponent {
  private readonly csvExportService = inject(CsvExportService);

  readonly data = inject(MODAL_DATA) as BlacklistModalData;
  readonly modalRef = inject(ModalRef);

  targetings = signal<Targeting[]>([]);
  isReadOnly = false;

  close() {
    this.modalRef.close();
  }

  save() {
    const toAdd = this.targetings().filter((t) => !this.data.blacklist?.includes(t));
    const toDelete = this.data.blacklist?.filter((t) => !this.targetings().includes(t));

    this.modalRef.close({
      toAdd,
      toDelete,
    });
  }

  downloadFile() {
    this.csvExportService.exportCsv(
      {
        prefix: "blacklist",
      },
      this.targetings(),
      [simpleField("matchType"), simpleField("targetingValue", "keyword")],
    );
  }
}
